/**
 * Strips trailing asterisks (and surrounding whitespace) from all keys in a
 * payload row object. Excel column headers sometimes end with "*" as a
 * required-field marker; this normalises them before sending to the backend.
 */
export const normalizePayloadRow = (row) => {
  const normalized = {};
  for (const k in row) {
    normalized[k.replace(/\s*\*+\s*$/, "").trim()] = row[k];
  }
  return normalized;
};

/**
 * Splits a "key:value" connector-config item string on the FIRST colon only,
 * then strips trailing asterisks from the key.
 *
 * Safe for values that contain colons (e.g. timestamps, URLs).
 */
export const splitConnectorItem = (item) => {
  const idx = item.indexOf(":");
  const rawKey = item.slice(0, idx);
  const value = item.slice(idx + 1);
  return { key: rawKey.replace(/\s*\*+\s*$/, "").trim(), value };
};
